export const AUTHENTICATE = 'authenticate';
export const LOG_OUT = 'log_out';
export const CREATE_PRIVATE_POLICY = 'create_private_policy';
export const AVAILABLE_COUNTRIES = 'available_countries';
export const AVAILABLE_LOCALES = 'available_locales';
export const SET_USER_EMAIL = 'set_user_email';
